<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #ImagenClientes
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 80px;border-radius:5px')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Aprobación de Imágenes de Clientes

    v-dialog(v-model='dialog', persistent max-width='700px')
      v-container(style='background-color:white !important;max-width: 700px;')
        v-card-title.justify-center
          span.headline Detalle de Solicitud
        div(style="margin-top: 20px;")
          v-flex(xs12, sm12, md12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12, md8)
                v-form

                  v-text-field(outline readonly v-model="form.cliente"
                    prepend-inner-icon="person" label="Cliente:")

                  v-text-field(outline readonly v-model="form.vendedor"
                    prepend-inner-icon="supervised_user_circle" label="Vendedor:")

                  div(v-if="form.imagen" style="text-align:center;margin-bottom:20px;")
                    v-img(
                      :src="ruta + form.imagen"
                      max-height="350"
                      contain
                      style="border-radius:5px;border:1px solid #eee;"
                    )
                    a(:href="ruta + form.imagen" target="_blank" style="font-size:12px;") Ver en tamaño completo

                  v-textarea(outline v-model="form.observacion"
                    prepend-inner-icon="comment" label="Observación:"
                    :disabled="form.estatus === 'Aprobado'")

                  v-layout(justify-center row wrap style="margin-top:10px;gap:10px;")
                    v-btn(v-if="form.estatus === 'Pendiente'" color="green" dark @click="aprobar()") Aprobar
                    v-btn(v-if="form.estatus === 'Pendiente'" color="red" dark @click="rechazar()") Rechazar
                    v-btn(color="grey" dark @click="close()") Cerrar

    v-layout(align-start='', justify-start='', row='', fill-height='', style="margin-top:10px;")
      v-flex(xs12, md12, sm12)
        v-card
          v-card-title
            span.title Lista de Solicitudes
            v-spacer
            v-select(
              v-model="filtroEstatus"
              :items="['Todos', 'Pendiente', 'Aprobado', 'Rechazado']"
              label="Filtrar por estatus"
              style="max-width:200px;"
              @change="cargarSolicitudes"
            )
          v-data-table(
            :headers="headers"
            :items="solicitudes"
            :rows-per-page-items="[10, 25, 50]"
          )
            template(v-slot:items="props")
              td {{ props.item.cliente }}
              td {{ props.item.vendedor }}
              td
                img(
                  v-if="props.item.imagen"
                  :src="ruta + props.item.imagen"
                  style="height:50px;width:auto;object-fit:cover;border-radius:3px;cursor:pointer;"
                  @click="verDetalles(props.item)"
                )
              td {{ formatDate(props.item.fechaCreacion) }}
              td
                v-chip(:color="getStatusColor(props.item.estatus)" dark small)
                  | {{ props.item.estatus | capitalize }}
              td
                v-btn(icon @click="verDetalles(props.item)")
                  v-icon remove_red_eye
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";

export default {
  name: "ImagenClientes",
  filters: {
    capitalize(val) {
      if (!val) return "";
      return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    }
  },
  data() {
    return {
      dialog: false,
      solicitudes: [],
      filtroEstatus: "Todos",
      ruta: `${server}:${port}`,
      form: {
        _id: "",
        cliente: "",
        vendedor: "",
        imagen: "",
        estatus: "",
        observacion: ""
      },
      cre: "",
      mod: "",
      elm: "",
      headers: [
        { text: "Cliente", value: "cliente" },
        { text: "Vendedor", value: "vendedor" },
        { text: "Imagen", value: "imagen", sortable: false },
        { text: "Fecha", value: "fechaCreacion" },
        { text: "Estado", value: "estatus" },
        { text: "Acciones", value: "acciones", sortable: false }
      ]
    };
  },
  mounted() {
    this.verificacion();
    this.cargarSolicitudes();
  },
  methods: {
    verificacion() {
      const permisos = this.$store.state.adminelgocho.permisos || [];
      for (let i = 0; i < permisos.length; i++) {
        if (permisos[i].ruta === "ImagenClientes") {
          for (let j = 0; j < permisos[i].accion.length; j++) {
            if (permisos[i].accion[j] === "Crear") this.cre = "yes";
            if (permisos[i].accion[j] === "Modificar") this.mod = "yes";
            if (permisos[i].accion[j] === "Eliminar") this.elm = "yes";
          }
        }
      }
    },
    async cargarSolicitudes() {
      try {
        const params =
          this.filtroEstatus !== "Todos"
            ? `?estatus=${this.filtroEstatus}`
            : "";
        const res = await Api.get(`clienteImagen${params}`);
        this.solicitudes = res.data;
      } catch (e) {
        // Error cargando solicitudes
      }
    },
    verDetalles(item) {
      this.form = {
        _id: item._id,
        cliente: item.cliente,
        vendedor: item.vendedor,
        imagen: item.imagen,
        estatus: item.estatus,
        observacion: item.observacion || ""
      };
      this.dialog = true;
    },
    async aprobar() {
      try {
        await Api.post(`clienteImagen/${this.form._id}/aprobar`);
        this.close();
        this.cargarSolicitudes();
      } catch (e) {
        var msg =
          (e.response && e.response.data && e.response.data.error) || e.message;
        alert("Error al aprobar: " + msg);
      }
    },
    async rechazar() {
      if (!this.form.observacion || !this.form.observacion.trim()) {
        alert("Debe ingresar una observación para rechazar.");
        return;
      }
      try {
        await Api.post(`clienteImagen/${this.form._id}/rechazar`, {
          observacion: this.form.observacion
        });
        this.close();
        this.cargarSolicitudes();
      } catch (e) {
        var msg =
          (e.response && e.response.data && e.response.data.error) || e.message;
        alert("Error al rechazar: " + msg);
      }
    },
    close() {
      this.dialog = false;
      this.form = {
        _id: "",
        cliente: "",
        vendedor: "",
        imagen: "",
        estatus: "",
        observacion: ""
      };
    },
    getStatusColor(estatus) {
      if (estatus === "Pendiente") return "orange";
      if (estatus === "Aprobado") return "green";
      if (estatus === "Rechazado") return "red";
      return "grey";
    },
    formatDate(fecha) {
      if (!fecha) return "";
      return this.$moment(fecha).format("DD/MM/YYYY HH:mm");
    }
  }
};
</script>
